import React, { Component } from 'react';

import ImageGallery from 'components/Building/Main/ImageGallery/src/ImageGallery';
import IconMap from 'react-icons/lib/fa/map';

import cn from 'classnames';
import styles from './Gallery.scss';

import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';

import iconPhotos from 'assets/images/icons/icon-photos.svg';
import placeholder from 'assets/images/banner-placeholder.jpg';
import FilterLabel from 'components/Buildings/FilterLabel';
import googleMapImg from 'assets/images/map.png';
import { YMapPoint, YCaption, YMap } from '../../../common/YMap';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from '../../../../services/ga';

class Gallery extends Component {
  handleOnClick = () => {
    const { openPopUp, setAlbumFromGalleryData, galleryData } = this.props;
    const index = this._imageGallery.getCurrentIndex();

    this.handleTrackEvent({
      eventName: 'buildingGalleryButtonsClick',
      eventLabel: 'posmotret_vse_foto'
    });

    openPopUp(index, 0);
    setAlbumFromGalleryData(index, galleryData);
  };

  handleShowMapClick = () => {
    const { openPopUp, onMap } = this.props;

    this.handleTrackEvent({
      eventName: 'buildingGalleryButtonsClick',
      eventLabel: 'na_karte'
    });

    openPopUp(0);
    onMap();
  };

  renderMap = (options) => {
    const { building } = this.props;

    const { latitude, longitude, pavilions } = building.data;

    const finished = (pavilions || []).some(pavilion => pavilion.construction_finished);

    const city = this.props.cities.find(city => city.areas.map(region => region.id).includes(this.props.building.data.region.id));
    const region = city.areas.find(reg => reg.id === this.props.building.data.region.id);
    const { name, latitude: lat, longitude: lng } = region.subareas.find(reg => reg.id === this.props.building.data.subregion.id);

    return (
      <YMap
        defaultState={{
          center: [latitude, longitude],
          zoom: 17
        }}
        defaultZoom={17}
      >
        <YMapPoint lat={latitude} lng={longitude} contexuality={finished ? 'success' : 'warningSuccess'} />
        <YCaption name={name} lat={lat} lng={lng} />
      </YMap>
    );
  }

  handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { building, profile, objectType } = this.props;
    const { data: { title, id } } = building;

    trackGA(gaEvent[eventName]({
      eventLabel,
      eventContent: eventContent || title,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  render() {
    const { className, building, galleryData, onMap, openPopUp, renderItem, t, profile, objectType } = this.props;
    const { latitude, longitude } = building.data;

    return (
      <div className={cn(styles.Gallery, className)}>
        {galleryData.itemsForGallery && galleryData.itemsForGallery.length ? (
          <div className={styles.Inner}>
            <div className={styles.Slider}>
              <ImageGallery isShort ref={i => (this._imageGallery = i)} onClick={this.handleOnClick} showIndex={false} slideOnThumbnailHover={false} showBullets={false} infinite={true} lazyLoad={true} showThumbnails={false} showFullscreenButton={false} showGalleryFullscreenButton={false} showPlayButton={false} showGalleryPlayButton={false} showNav={true} slideInterval={2000} items={galleryData.itemsForGallery} defaultImage={placeholder} renderItem={renderItem} galleryData={galleryData} profile={profile} buildingData={building.data} objectType={objectType} />
              <FilterLabel isBlackList={this.props.building.data.additional.black_list} isNew={this.props.building.data.additional.new} isNedvex={this.props.building.data.additional.nedvex} />
              <div className={styles.GalleryButtons}>
                <div onClick={this.handleOnClick} className={styles.GalleryButton}>
                  <img src={iconPhotos} alt="" />
                  {t('components.building.main.gallery.showAll')} ({galleryData.itemsForGallery.length})
                </div>
                <div onClick={this.handleShowMapClick} className={styles.GalleryButton}>
                  <img src={googleMapImg} alt="" /> {t('components.building.main.gallery.showOnMap')}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.Inner}>
            <div style={{ width: '100%' }}>
              {latitude && longitude ? (
                <div className={cn(styles.MiniPreview, styles.MapPreview)}>
                  {this.renderMap()}
                  <div
                    onClick={() => {
                      openPopUp(0);
                      onMap();
                    }}
                    className={cn(styles.MapCover)}
                  >
                    <div className={styles.Div}>
                      <IconMap className={styles.MapIcon} />
                      <span>{t('components.building.main.gallery.showOnMap')}</span>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(connect(
  (state) => ({
    cities: state.building.cities
  }),
  { setPopUp }
)(Gallery));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Gallery/Gallery.js